import { ActionReducer } from '@ngrx/store';
import { StateManagementHelpers } from '../../helpers';
import * as AccountManagerContactActions from '../actions/account-manager-contact.actions';
import { IAccountManagerContactStore } from '../interfaces/account-manager-contact-store.interface';

const defaultAccountManagerContact: IAccountManagerContactStore = {
  firstName: 'Now',
  lastName: 'Representative',
  email: 'sales@nowcorp.com',
  phoneNumber: '(855) 966-9435',
};

export const accountManagerContactReducer: ActionReducer<
  IAccountManagerContactStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: IAccountManagerContactStore = defaultAccountManagerContact,
  action: any
): IAccountManagerContactStore | undefined => {
  switch (action.type) {
    case AccountManagerContactActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        id: action.id,
        firstName: action.firstName,
        lastName: action.lastName,
        email: action.email,
        phoneNumber: action.phoneNumber,
      }) as IAccountManagerContactStore;
    default:
      return state;
  }
};
